module.exports = function (element) {
    function filterBlock(el) {
        let node = $(el);
        let link = node.find('.js-filter-link');
        let block = node.find('.js-filter-block');
        let links = node.find('.js-filter-block a');

        let refreshTitle = function (txt) {
            txt = node.find('.js-selected').text()
            if (txt) {
                link.find('span:eq(0)').text(txt);
            }
        }
        refreshTitle();

        let closeAll = function (event) {
            if (block.is(":visible")) {
                block.toggle();
                link.find('span:eq(1)')
                    .toggleClass('filter__select__up');
            }
        };

        links.on({
            click: function () {
                block.toggle();
                link.find('span:eq(1)')
                    .toggleClass('filter__select__up');

                links.removeClass('selected js-selected');
                $(this).addClass('selected js-selected');

                refreshTitle();

                return true;
            }
        });

        link.on({
            click: function () {
                block.toggle();
                link.find('span:eq(1)')
                    .toggleClass('filter__select__up');
                return false;
            }
        });

        let body = $(document.body);
        body.on('click', closeAll);
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    filterBlock(element);
};
